<template>
    <Sheet v-loading="loading.actions['systemNews']">
        <h2>{{routeTitle}}</h2>
        <table cellpadding="0" cellspacing="0" class="ncut-table-search" style="width: 100%; padding: 0.5em;">
          <tbody>
            <tr>
              <td style="width:5em;">查詢條件</td>
              <td class="ncut-base-form-text" style="width:8em;">使用者帳號：</td>
              <td class="ncut-base-form-ipt" style="padding: 0.25em; width:6em;" tabindex="1">
                <el-input v-model="queryInfo.text1" placeholder="請輸入使用者帳號："></el-input>
              </td>
              <td class="ncut-base-form-text" style="width:8em;">日期起迄：</td>
              <td style="width:5.5em; ">
                <el-date-picker
                  v-model="tmpDate"
                  :unlink-panels=true
                  type="daterange"
                  range-separator="至"
                  start-placeholder="開始日期"
                  end-placeholder="结束日期"
                  tabindex="3"
                  :picker-options="pickerOptions1">
                </el-date-picker> 
              </td>
              <td style="padding: 0 0 0 3em;">
                <el-button
                  @click="query"
                  icon="el-icon-refresh">
                  重新整理
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
        <el-tabs type="border-card"
            v-model="activeName"
            @tab-click="handleClick">
            <el-tab-pane name="p1">
                <span slot="label"><i class="el-icon-setting"></i> 明細資料</span>

                <el-row :gutter="24">
                  <el-col :span="10">
                    <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="width:100%">
                      <thead class="ncut-thead-menu">
                        <tr>
                          <th style="width: 1em;"></th>
                          <th>
                            使用者帳號
                          </th>
                          <th style="width: 20em;">
                            執行時間
                          </th>
                        </tr>
                      </thead>
                        <tbody class="ncut-tbody-menu">
                          <tr v-for="(item, index) in filteredDocs" :key="item.id" :index="item.id" :name="item.id"
                                @click="rowClick(index, item)"
                                v-bind:class="{ selected: index == selectedRowIndex }">
                              <td>{{((currentPage-1) * pageSize)+ index+1}}</td>
                              <td style="text-align: left;">{{item.text1}}</td>
                              <td style="text-align:left;">起:{{item.startDate | dateFormat}} - 迄:{{item.endDate | dateFormat}}</td>
                          </tr>
                          <tr v-if="0 == logList.length">
                            <td colspan="3">無</td>
                          </tr>
                        </tbody>
                    </table>
                    <el-pagination
                      @current-change="handleCurrentChange" 
                      background
                      layout="prev, pager, next"
                      :pager-count="11"
                      :page-size="pageSize"
                      :total="logList.length"
                      v-if="logList.length>pageSize">
                    </el-pagination>
                  </el-col>
                  <el-col :xl="14" :lg="14" :md="14" :sm="24" :xs="24">
                    <template 
                      v-if="(null != logData) && (-1 < selectedRowIndex)">
                      <table cellpadding="0" cellspacing="0" style="width:100%">
                        <tbody>
                          <tr>
                            <td class="ncut-edit-form-text ncut-require-title" style="width:8em;">代碼：</td>
                            <td class="ncut-base-form-ipt" style="padding-top: 15px;" colspan="3">
                              {{logData.id}}
                            </td>
                          </tr> 
                          <tr>
                            <td class="ncut-edit-form-text">時間：</td>
                            <td class="ncut-base-form-ipt" colspan="3">
                              起:{{logData.startTime | dateFormat}} - 迄:{{logData.endTime | dateFormat}}
                              <!-- <el-date-picker
                                v-model="tmpDate"
                                :unlink-panels=true
                                type="daterange"
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="结束日期"
                                tabindex="3"
                                :picker-options="pickerOptions1">
                              </el-date-picker>  -->
                            </td>
                          </tr>
                          <tr>
                            <td class="ncut-edit-form-text ncut-require-title">使用者帳號：</td>
                            <td class="ncut-base-form-ipt" colspan="3">
                              {{logData.userId}}
                              <!-- <el-input v-model="logData.userId" placeholder="請輸入使用者帳號："  tabindex="4"
                                maxlength="10"
                                show-word-limit></el-input> -->
                            </td>
                          </tr>
                          <tr>
                            <td class="ncut-edit-form-text ncut-require-title">IP 位址：</td>
                            <td class="ncut-base-form-ipt" colspan="3">
                              {{logData.ip}}
                              <!-- <el-input v-model="logData.ip" placeholder="請輸入IP 位址："  tabindex="4"
                                maxlength="15"
                                show-word-limit></el-input> -->
                            </td>
                          </tr>
                          <tr>
                            <td class="ncut-edit-form-text ncut-require-title">備註：</td>
                            <td class="ncut-base-form-ipt" colspan="3">
                              <el-input type="textarea" :rows=3 placeholder="請輸入備註：" tabindex="6"
                                v-model="logData.othersInfo" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <el-row style="padding: 0.25em 2em; display: inline-block;" tabindex="11">
                        <el-button type="success" @click="save()"><i class="el-icon-check"></i>&nbsp;{{$t('Save_cmd')}}</el-button>
                      </el-row>
                    </template>
                  </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane name="p2">
                <span slot="label"><i class="el-icon-document"></i> 統計圖表</span>
                  <GChart
                    type="BarChart"
                    :data="chartData"
                    :options="chartOptions"
                  />
            </el-tab-pane>
        </el-tabs>    
  </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import routeTitleMixin from './routeTitleMixin';
import {base} from '../constants';
import UploadMixin from '../uploadMixin';
import { GChart } from 'vue-google-charts'

export default {
  name: 'log',
  mixins: [routeTitleMixin, UploadMixin],
  components: {
    GChart
  },
  data () {
    return {
      activeName: 'p1',
      queryInfo: {
        id  : 0,
        text1: ''
      },
      base: base,
      mode: 1,
      currentPage: 1,
      selectedRowIndex: -1,
      pageSize: 10,
      tmpDate: [new Date(), new Date()],
      pickerOptions1: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      chartData: [],
      chartOptions: {
        chart: {
          title: '每日登入次數統計',
        },
        colors: ['#1b9e77', '#d95f02', '#7570b3']
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('auth', [ 'userId']),
    ...mapState('systemNews', [ 'logList', 'logData', 'logChart']),
    
    pBtnColor () {
      return (this.currPdfPage==1?'#b2bbbe': '#207f4c');
    },
    nBtnColor () {
      return (this.currPdfPage==this.pageCount?'#b2bbbe': '#c1651a');
    },
  	filteredDocs: function(){
      let data = []
      if (this.logList != null) {          
        data = this.logList.slice((this.currentPage-1)*this.pageSize, this.currentPage*this.pageSize)
      }   
      return data
    },
  },
  filters: {  
    dateFormat:function(input) {   
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();  
       return  year+ '/' + month + '/' + day + ' ' + d.getHours() + ':' +  + d.getMinutes(); 
    }  
  },
  methods: {
    ...mapActions('systemNews', {
    //getLogList: 'getLogList',
      queryLog: 'getLogByInfo',
      getLogData: 'getLogData',
      getLogChart: 'getChartByInfo',
      update: 'updateLogData',
    }),
    isNull(data) {
      var ret = ((data != null) && (data != undefined) && (data != "null") ? false : true);
      return ret;
    },
    isShow (item) {
      return (item.status==null || item.status!='D')
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    async handleClick (tab, event) {
      var page = parseInt(tab.index);
      if (1 == page) {
        var ret = await this.getLogChart(this.queryInfo);
        if (ret.success) {
          this.chartData = [['日期', '次數']]; 
          this.logChart.forEach((item,index)=>{
            this.chartData.push([item.text1, item.id])
          })
        } else {
          this.chartData = [];
        }
      } 
    },
    async query() {
        this.queryInfo.startDate = this.tmpDate[0];
        this.queryInfo.endDate = this.tmpDate[1];
        await this.queryLog(this.queryInfo);
        this.selectedRowIndex = -1;
        this.activeName = 'p1';
    },
    async rowClick(index, item) {
      this.selectedRowIndex = index;
      
      const {success} = await this.getLogData(item.id);

      if (success) {
        this.tmpDate = [ this.logData.startTime, this.logData.endTime];
      }
    },
    checkSaveData () {
      let msg = '';

      return msg;
    },
    async save () {
      let msg = this.checkSaveData();
      if (msg.length === 0) {       
        this.logData.startTime = this.tmpDate[0];
        this.logData.endTime = this.tmpDate[1];
        this.logData.updateUser = this.userId;
        const {success} = await this.update({
                            ...this.logData,
                        });

        if (success) {
          this.$message({
                          type: 'success',
                          message: '異動成功'
                        });
          await this.getLogList();
          this.selectedRowIndex = -1;
        } else {
          this.$message({
                          type: 'danger',
                          message: '異動失敗，請重試一次'
                        });
        }
      } else {
        this.$message.error('對不起,' + msg)
        return false
      } 
    },
  },

  async created() {
    //await this.getLogList();
    //this.selectedRowIndex = -1;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
